import React from 'react'
import './LoginLayout.css'

const LoginLayout = () => {
  return (
    <>
    </>
  )
}

export default LoginLayout